import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M224 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64m0 96c4.5 0 8.9-.5 13.1-1.3l38.1 83.2c-26.6 17.2-45.4 45.4-50.1 78.1H126c-7.1-27.6-32.2-48-62-48-35.3 0-64 28.7-64 64s28.7 64 64 64c29.8 0 54.9-20.4 62-48h99.2c7.8 54.3 54.4 96 110.9 96 35 0 66.3-16.1 86.8-41.2l91.8 55.1c-1.7 5.8-2.6 11.9-2.6 18.2 0 35.3 28.7 64 64 64s64-28.7 64-64-28.7-64-64-64c-17.5 0-33.4 7-44.9 18.4l-91.8-55.1c5.6-13.3 8.7-28 8.7-43.3 0-18.7-4.6-36.3-12.7-51.8L537.2 179c10.8 8.2 24.2 13.1 38.8 13.1 35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64c0 9.1 1.9 17.8 5.4 25.7l-100.8 72.4c-20.4-21.1-49-34.2-80.6-34.2-11 0-21.6 1.6-31.7 4.5l-38.5-84.1c13.6-11.7 22.2-29 22.2-48.4 0-35.3-28.7-64-64-64s-64 28.7-64 64 28.7 64 64 64m352-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64m-32 352a32 32 0 1 1 64 0 32 32 0 1 1-64 0M64 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64m272-48a80 80 0 1 1 0 160 80 80 0 1 1 0-160"
    }, null, -1)
  ])))
}
export default { render: render }